import type { estypes } from '@elastic/elasticsearch'

export const superJiraMetadataMapping = {
  key: {
    type: 'keyword',
    index: false,
  },
  type: {
    type: 'keyword',
    index: false,
  },
  creator: {
    type: 'keyword',
    index: false,
  },
  timeSpent: {
    type: 'float',
    index: false,
  },
  reporter: {
    type: 'keyword',
    index: false,
  },
  percentProgress: {
    type: 'float',
    index: false,
  },
  priority: {
    type: 'keyword',
    index: false,
  },
  resolution: {
    type: 'keyword',
    index: false,
  },
  labels: {
    type: 'keyword',
    index: false,
  },
  resolutionDate: {
    type: 'date',
    index: false,
  },
  dueDate: {
    type: 'date',
    index: false,
  },
  assignee: {
    type: 'keyword',
    index: false,
  },
  status: {
    type: 'keyword',
    index: false,
  },
} satisfies Record<string, estypes.MappingProperty>
